import { CompanyType, IntelCompaniesSortBy, SortDirection } from '@@types/api.types';
import type { SortingState } from '@tanstack/react-table';

export const DEFAULT_ORGANIZATIONS_PAGE_SIZE = 25;
export const DEFAULT_ORGANIZATIONS_SORTING: SortingState = [{ desc: false, id: 'name' }];
export const INTEL_ORGANIZATION_COMPANY_TYPES = [
  CompanyType.COMMERCIAL,
  CompanyType.RESEARCH,
  CompanyType.RESEARCH_PROJECT,
];

const SORT_FIELD_BY_COLUMN_ID: Record<string, IntelCompaniesSortBy> = {
  location: IntelCompaniesSortBy.Location,
  name: IntelCompaniesSortBy.Name,
  productsCount: IntelCompaniesSortBy.ProductsCount,
  technologiesCount: IntelCompaniesSortBy.TechnologiesCount,
  type: IntelCompaniesSortBy.Type,
};

export const deriveOrganizationSort = (
  sortingState: SortingState,
): { sortBy: IntelCompaniesSortBy; sortDirection: SortDirection } => {
  const sortItem = sortingState[0];

  return {
    sortBy: sortItem ? (SORT_FIELD_BY_COLUMN_ID[sortItem.id] ?? IntelCompaniesSortBy.Name) : IntelCompaniesSortBy.Name,
    sortDirection: sortItem?.desc ? SortDirection.DESC : SortDirection.ASC,
  };
};
